import { Fragment, useContext } from "react";
import { CommitementDetails } from "../../../../../types/Dossiers";
import { Typography, CardContent, CardActions, Box, Card } from "@mui/material";
import CircularProgressWithRatio from "../../../../UIElements/CircularProgressWithRatio/CircularProgressWithRatio";
import { ReactComponent as ArrowRight } from "../../../../../public/icons/Arrow_Right_LG.svg";

import ReactSvgIcon from "../../../../UIElements/ReactSvgIcon";
import { LayoutBarContext } from "../../../../../contexts";
import Commitment from "./Commitment";
import {
    getCircularProgressLabelByUserRole,
    getColorByPercent,
} from "../../utils";
import { useCommitment } from "./useCommitment";
import { useLocalStorage } from "../../../../../hooks";
import { Session } from "../../../../../types";
import { sessionStorageKey } from "../../../../../consts";
import { DossierInfosType } from "../../Dossier";

type CommitmentProp = {
    commitmentInfos: CommitementDetails;

    dossierInfos: DossierInfosType;
};

export default function CommitmentCard({
    commitmentInfos,
    dossierInfos,
}: CommitmentProp) {
    const { updateContent } = useContext(LayoutBarContext);

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser, currentUserRoleId: userRoleId },
    } = session;

    const { ratio, circualProgressRatio } =
        useCommitment(commitmentInfos, userRoleId) || {};

    const card = (
        <Fragment>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    flexShrink: 0,
                    alignSelf: "stretch",
                    height: "inherit",
                }}
            >
                <CardContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.75rem",
                        padding: 0,

                        alignSelf: "stretch",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "1rem",

                            alignSelf: "stretch",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "0.25rem",

                                alignSelf: "stretch",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#023",

                                    fontFamily: "Roboto",
                                    fontSize: "1.125rem",
                                    fontStyle: "normal",
                                    fontWeight: 500,
                                    lineHeight: "normal",
                                }}
                            >
                                {`${commitmentInfos.position} ${commitmentInfos.name}`}
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",

                            alignItems: "center",
                            gap: "0.5rem",
                            alignSelf: "stretch",
                        }}
                    >
                        <Typography
                            sx={{
                                flex: "1 0 0",
                                color: "#555A5D",

                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal",
                            }}
                        >
                            {getCircularProgressLabelByUserRole(userRoleId)}
                        </Typography>
                        {ratio ? (
                            <CircularProgressWithRatio
                                value={
                                    !circualProgressRatio ||
                                    isNaN(circualProgressRatio)
                                        ? 0
                                        : circualProgressRatio
                                }
                                ratio={ratio}
                                circularProgressProps={{
                                    circualcolor:
                                        circualProgressRatio !== undefined
                                            ? getColorByPercent(
                                                  circualProgressRatio
                                              )
                                            : "#F43B00",
                                }}
                            />
                        ) : null}
                    </Box>
                </CardContent>
                <CardActions
                    sx={{
                        padding: 0,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            updateContent(
                                <Commitment
                                    dossierInfos={dossierInfos}
                                    commitmentId={commitmentInfos.id}
                                />
                            );
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#005499",

                                fontFamily: "Roboto",
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "normal",
                            }}
                        >
                            Consulter
                        </Typography>
                        <ReactSvgIcon
                            sx={{
                                "&.MuiSvgIcon-root": {
                                    height: "1.25rem",
                                    width: "1.25rem",
                                },
                            }}
                            ReactIcon={ArrowRight}
                            reactIconProps={{
                                width: 24,
                                height: 24,
                            }}
                        />
                    </Box>
                </CardActions>
            </Box>
        </Fragment>
    );

    return (
        <Box
            sx={{
                // height: "auto",
                // height: "100%",
                // width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2.1875rem",

                alignSelf: "stretch",
                borderRadius: "1.5rem",
                boxShadow: "0px 4px 30px 0px #E3E6E8",
            }}
        >
            <Card
                variant="outlined"
                sx={{
                    display: "flex",
                    // height: "195px",
                    padding: "1.5rem",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2.25rem",
                    alignSelf: "stretch",
                    height: "12.1875rem",
                    borderRadius: "1.5rem",
                    background: " #FFF",
                    border: "none",
                    /* Ombre card */
                    boxShadow: "0px 4px 30px 0px #E3E6E8",
                }}
            >
                {card}
            </Card>
        </Box>
    );
}
